<template>
  <span class="ya-te-badge-optional co-display-14 badge rounded border-0 bg-co-gray-400 p-2 text-co-gray-50">
    <slot>任意</slot>
  </span>
</template>

<style scoped>
.ya-te-badge-optional {
  color: #fff;
  background-color: #a1a1a1;
}
</style>
